import React from "../_snowpack/pkg/react.js";
import styled from "../_snowpack/pkg/@emotion/styled.js";
import {t} from "../common/i18n.js";
import {Text, Title} from "./typo.js";
import {colors, fontFamily, gap, lineHeight, media} from "./theme.js";
import Button from "./button.js";
import {Bin as BinIcon, Edit as EditIcon} from "./icons.js";
import {getPageProduct, getTranslatedName, withAttrs} from "../common/utils.js";
import ProductVariant from "./product-variant.js";
import {formatCurrency, getUrl} from "../common/universal.js";
import {Routes} from "../typings/routes.js";
import ProductOption from "./product-option.js";
import ProductPreviewImage from "./product-preview-image.js";
import VariableProductConfigValues from "./variable-product-config-values.js";
export default function CartItem(props) {
  const {
    id,
    withVariants,
    withOptions,
    widthButtons,
    section,
    product_page,
    category_page,
    article,
    option_articles,
    inside_print_template_path,
    outside_print_template_path,
    quantity,
    editor_config,
    onDeleteClick,
    product_config,
    order_config
  } = props;
  if (!product_page)
    return null;
  const editUrl = getUrl(Routes.cartEditItem, {item_id: id});
  const product = getPageProduct(product_page);
  const isModelProductOrder = product.component === "model_product";
  const isStandardProductOrder = product.component === "standard_product";
  const isVariableProductOrder = product.component === "variable_product";
  const {
    length: product_length,
    width: product_width,
    height: product_height
  } = product_config || {};
  const {cf_inner_dimensions, cf_outer_dimensions, cf_shipping_weight} = article;
  const weight = isVariableProductOrder ? order_config?.shipping_unit_weight : cf_shipping_weight;
  return /* @__PURE__ */ React.createElement(ItemContainer, null, /* @__PURE__ */ React.createElement(ItemImageContainer, null, /* @__PURE__ */ React.createElement(ProductPreviewImage, {
    article,
    config: editor_config,
    page: product_page,
    categoryPage: category_page,
    insidePrintPath: inside_print_template_path,
    outsidePrintPath: outside_print_template_path
  })), /* @__PURE__ */ React.createElement(ItemInner, null, /* @__PURE__ */ React.createElement(ItemHeader, null, /* @__PURE__ */ React.createElement(ItemTitle, {
    level: 3
  }, getTranslatedName(product_page)), /* @__PURE__ */ React.createElement(ItemPrice, {
    as: "div"
  }, /* @__PURE__ */ React.createElement("div", null, formatCurrency(article.net_price)), /* @__PURE__ */ React.createElement("small", null, formatCurrency(article.unit_price), " / ", t("Stk")))), isModelProductOrder && /* @__PURE__ */ React.createElement(ItemSectionGrid, {
    cols: 2
  }, article?.variant && /* @__PURE__ */ React.createElement(ItemCol, null, /* @__PURE__ */ React.createElement(ItemOptionLabel, null, t("Variante")), /* @__PURE__ */ React.createElement(ProductVariant, {
    article,
    variant: article.variant,
    readOnly: true
  }))), !isModelProductOrder && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ItemSectionGrid, {
    cols: 3
  }, /* @__PURE__ */ React.createElement(ItemCol, null, /* @__PURE__ */ React.createElement(ItemOptionLabel, null, t("Dimensionen")), isVariableProductOrder && /* @__PURE__ */ React.createElement(ItemOptionValue, null, /* @__PURE__ */ React.createElement(NoBreak, null, t("Länge: "), product_length, t("mm")), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement(NoBreak, null, t("Breite: "), product_width, t("mm")), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement(NoBreak, null, t("Höhe: "), product_height, t("mm"))), isStandardProductOrder && /* @__PURE__ */ React.createElement(React.Fragment, null, cf_inner_dimensions === cf_outer_dimensions ? /* @__PURE__ */ React.createElement(ItemOptionValue, null, /* @__PURE__ */ React.createElement(NoBreak, null, cf_inner_dimensions)) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ItemOptionValue, null, t("Innen"), ": ", /* @__PURE__ */ React.createElement(NoBreak, null, cf_inner_dimensions)), /* @__PURE__ */ React.createElement(ItemOptionValue, null, t("Außen"), ": ", /* @__PURE__ */ React.createElement(NoBreak, null, cf_outer_dimensions))))), /* @__PURE__ */ React.createElement(ItemCol, null, /* @__PURE__ */ React.createElement(ItemOptionLabel, null, t("Menge")), /* @__PURE__ */ React.createElement(ItemOptionValue, null, quantity, " ", t("Stück"))), /* @__PURE__ */ React.createElement(ItemCol, null, /* @__PURE__ */ React.createElement(ItemOptionLabel, null, t("Stückgewicht")), /* @__PURE__ */ React.createElement(ItemOptionValue, null, weight, " ", t("g"))))), isVariableProductOrder && /* @__PURE__ */ React.createElement(ItemSectionGrid, {
    cols: 3
  }, /* @__PURE__ */ React.createElement(VariableProductConfigValues, {
    page: product_page,
    config: product_config
  })), withVariants && article.variant && !isModelProductOrder && /* @__PURE__ */ React.createElement(ItemSection, null, /* @__PURE__ */ React.createElement(ItemOption, null, /* @__PURE__ */ React.createElement(ItemOptionLabel, null, t("Variante")), /* @__PURE__ */ React.createElement(ProductVariant, {
    article,
    variant: article.variant,
    readOnly: true
  }))), withOptions && option_articles && option_articles.length !== 0 && /* @__PURE__ */ React.createElement(ItemSection, null, /* @__PURE__ */ React.createElement(ItemOption, null, /* @__PURE__ */ React.createElement(ItemOptionLabel, null, t("Zusätzliche Optionen")), option_articles.map((o) => /* @__PURE__ */ React.createElement(ProductOption, {
    key: o.id,
    article: o,
    option: o.option,
    quantity,
    readOnly: true
  })))), section && /* @__PURE__ */ React.createElement(ItemSection, null, section), widthButtons && /* @__PURE__ */ React.createElement(FooterSection, null, !isModelProductOrder && /* @__PURE__ */ React.createElement(ItemButton, {
    href: editUrl
  }, t("Bearbeiten"), /* @__PURE__ */ React.createElement(EditIcon, null)), /* @__PURE__ */ React.createElement(ItemButton, {
    onClick: () => onDeleteClick && onDeleteClick(id)
  }, t("Löschen"), /* @__PURE__ */ React.createElement(BinIcon, null)))));
}
const ItemContainer = styled.div`
  display: flex;
  padding: 18px;
  border-radius: 4px;
  box-shadow: 0px 8px 24px 0px rgba(163, 177, 191, 0.35);

  ${media.phone} {
    flex-wrap: wrap;
  }
`;
const ItemImageContainer = styled.div`
  width: 116px;
  margin-right: 20px;

  ${media.cartSmall} {
    width: 100%;
    margin: 0 0 20px;
  }
`;
const NoBreak = styled.span`
  white-space: nowrap;
`;
const ItemInner = styled.div`
  flex: 1;
`;
const ItemSection = styled.div`
  display: flex;
  padding: 18px 0;
  border-top: 1px solid ${colors.b6};
  border-bottom: 1px solid ${colors.b6};

  &:first-of-type {
    padding-top: 0;
    border-top: none;
  }

  &:last-of-type {
    padding-bottom: 0;
    border-bottom: none;
  }
`;
const FooterSection = styled(ItemSection)`
  > * {
    margin-left: auto;
  }
`;
const ItemSectionGrid = styled(ItemSection)`
  display: grid;
  grid-gap: 15px;

  grid-template-columns: ${(props) => props.cols === 2 ? "1fr 1fr" : "1fr 1fr 1fr"};

  ${media.phone} {
    grid-template-columns: 1fr;
  }
`;
const ItemCol = styled.div``;
const ItemHeader = styled(ItemSection)`
  justify-content: space-between;

  ${media.phone} {
    flex-direction: column;
    ${gap("10px", "column")}
  }
`;
const ItemTitle = styled(Title)`
  font-size: 20px;
`;
const ItemPrice = styled(Title)`
  font-size: 20px;
  text-align: right;
  line-height: 20px;

  small {
    font-size: 12px;
    color: ${colors.b4};
    font-weight: 400;
  }
`;
const ItemOption = styled.div`
  & + & {
    margin-left: 40px;
  }
`;
const ItemOptionLabel = styled.div`
  font-family: ${fontFamily.secondary};
  font-weight: 700;
  font-size: 12px;
  line-height: ${lineHeight};
  margin-bottom: 8px;
  text-transform: uppercase;
  color: ${colors.b1};
`;
const ItemOptionValue = styled(withAttrs(Text, {as: "div"}))`
  font-family: ${fontFamily.secondary};
  font-weight: 500;
  line-height: ${lineHeight};
  font-size: 12px;
`;
const ItemButton = styled(withAttrs(Button, {small: true, secondary: true}))`
  & + & {
    margin-left: 16px;
  }
`;
